import {Message} from '../types';
import {PlatformPropertyCard} from "@flexinet/ui-components";
import {
    Accordion,
    Stack
} from "@mantine/core";
import {AiOutlineSetting} from "react-icons/ai";
import {MessageCard} from "./MessageCard";
import {useMessageProfile} from '../hooks/useMessageProfile';
import {AttachmentsList} from '../components/AttachmentsList';
import {useContactByEmail} from '../../contacts/hooks/useContactByEmail';
import {parseEmailAddress} from '../utils/parseEmailAddress';


export const Profile = ({record, onAddToContacts}: { record: Message, onAddToContacts?: () => void }) => {
    const email = record.fromText ? parseEmailAddress(record.fromText).email : undefined;
    const {contact: existingContact, loading: contactLoading} = useContactByEmail(email);

    const {
        properties,
        metadata
    } = useMessageProfile(
        record,
        contactLoading ? undefined : onAddToContacts,
        contactLoading ? undefined : existingContact,
    );

    return (
        <Stack gap={'xl'}>
            <MessageCard record={record}/>

            <AttachmentsList attachments={record.attachments || []}/>

            <PlatformPropertyCard properties={properties}/>


            <Accordion defaultValue={''}>
                <Accordion.Item key={'metadata'} value="metadata">
                    <Accordion.Control icon={<AiOutlineSetting/>}>Message Metadata</Accordion.Control>
                    <Accordion.Panel>
                        <PlatformPropertyCard properties={metadata}/>
                    </Accordion.Panel>
                </Accordion.Item>

            </Accordion>


        </Stack>
    );

};
